module.exports = __webpack_public_path__ + "static/media/Tenderhousekeeping.c2766b69.pdf";